import React, { useState } from "react";
import { ModalEditAllItems } from "./modal";
import { Button } from "react-bootstrap";

export function EditAllModal({name, disabled}){
  const [show, setShow] = useState(false)
  return (
    <>
      <ModalEditAllItems name={name} show={show} setShow={setShow}/>
      <Button disabled={disabled} onClick={()=>setShow(true)}>
        Edit All Items
      </Button>
    </>
  )



}